// Native scrolling wrapper. Lenis was removed because it intercepted the
// scroll and could leave lower sections unreachable on some setups.
export default function SmoothScroll({ children }) {
  return children;
}
